<template>
	<div id="contact-container">
		<router-link to="contact" style="background-image:" id="contact-link">
		</router-link>
	</div>
</template>

<script>
import axios from "axios"
	export default {
		name: 'LandingContactLabel',
		data: 
			function() {
				return {
					contact: "Kontakt",
					contactIcon: require('../../../assets/Icons/Kontakt 20-12.svg'),
					iconUrl: '../../../assets/Icons/Kontakt 20-12.svg',
					svg: "sdfsdf",
				}
			},
		methods: {
			linkTo() {
				this.$emit('contactEvent');
			}
		},

		async mounted() {
			var el = document.getElementById("contact-link");
			el.innerHTML = await axios.get(this.contactIcon).then(r => r.data);
		}
	}
</script>

<style scoped>
	#contact-container {
		position: fixed;
		top: 30%;
		right: 0px;
		height: 85px;
		width: 85px;
		z-index: 10000;
	}

	.text-wrapper {
		position: absolute;
		bottom: 10pt;
		left: 50%;
		transform: translateX(-50%);
		-webkit-transform: translateX(-50%);
	}
	
	a {

	}

	img {
		width: 85px;
		height: auto;
	}
	
	@media (max-width: 991px) {
		#contact-container {
			width: 65px;
			height: auto;
		}
	}

	@media (max-width: 767px) {
		#contact-container {
			display: none
		}
	}
</style>